(function () {
  if (window.__zumzzFunnelEventsLoaded) return;
  window.__zumzzFunnelEventsLoaded = true;

  var pendingInteraction = null;
  var drawerWasOpen = false;
  var cartSyncTimer = null;
  var cartSyncRunning = false;
  var cartSyncQueued = false;
  var cartSyncOpenDrawer = false;
  var cartMutationRevision = 0;

  function emit(name, detail) {
    detail = detail || {};

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'zz_' + name,
      zz_funnel: detail
    });

    document.dispatchEvent(new CustomEvent('zumzz:' + name, { detail: detail }));

    var attempts = 0;
    function sendToClarity() {
      attempts += 1;
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
      } else if (attempts < 4) {
        window.setTimeout(sendToClarity, attempts * 500);
      }
    }
    sendToClarity();
  }

  function buttonContext(button) {
    if (!button) return {};
    var form = button.closest('form');
    var variantInput = form && form.querySelector('[name="id"]');
    return {
      source: button.closest('cart-drawer') ? 'cart_drawer' :
        button.closest('.sticky-atc') ? 'sticky_atc' :
        button.closest('[class*="zcat-"] , [class*="zcg-"]') ? 'collection' : 'product_page',
      product_path: window.location.pathname,
      variant_id: variantInput ? variantInput.value : button.dataset.variantId || '',
      label: (button.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80),
      cro_experiment: button.dataset.zzCroTest || '',
      cro_variant: button.dataset.zzCroVariant || ''
    };
  }

  function readStoredValue(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStoredValue(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {}
  }

  function chooseCroVariant(key) {
    var stored = readStoredValue(window.localStorage, key);
    if (stored === 'control' || stored === 'challenger') return stored;

    var randomValue;
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      randomValue = values[0] / 4294967296;
    } else {
      randomValue = Math.random();
    }

    var chosen = randomValue < 0.5 ? 'control' : 'challenger';
    writeStoredValue(window.localStorage, key, chosen);
    return chosen;
  }

  function syncMobileAssurance() {
    var assurance = document.querySelector('[data-zz-mobile-assurance]');
    if (!assurance) return;

    var deliveryTarget = assurance.querySelector('[data-zz-delivery-copy]');
    var source = Array.from(document.querySelectorAll(
      'dynamic-dates .estimated-shipping__text.new[data-dynamic-date="true"], current-date'
    )).find(function (element) {
      return !element.closest('[data-zz-mobile-assurance]');
    });
    var sourceText = source && source.textContent ? source.textContent.trim().replace(/\s+/g, ' ') : '';

    if (deliveryTarget && sourceText && sourceText.indexOf('-') === -1) {
      deliveryTarget.textContent = sourceText.replace(/\.$/, '');
    }

    if (source) {
      var sourceWrapper = source.closest('.product__text-container') ||
        (source.parentElement && source.parentElement.parentElement);
      if (sourceWrapper) sourceWrapper.classList.add('zz-cro-mobile-source-hidden');
    }

    var productInfo = assurance.closest('.product__info-container, [id^="ProductInfo-"]');
    if (!productInfo) return;
    Array.from(productInfo.querySelectorAll('a[href*="shipping"]')).forEach(function (link) {
      if (!/pouzeć|cash on delivery|nachnahme/i.test(link.textContent || '')) return;
      var wrapper = link.closest('[style*="--margin-top"]');
      if (wrapper) wrapper.classList.add('zz-cro-mobile-source-hidden');
    });
  }

  function setupPdpCro() {
    var button = document.querySelector('.main-product-form [data-zz-cro-test]');
    if (button) {
      var experiment = button.dataset.zzCroTest;
      var variant = chooseCroVariant('zz_cro_' + experiment);
      var label = button.querySelector('.main-atc__label__text');
      var expectedLabel = variant === 'challenger' ? button.dataset.zzCroChallenger : button.dataset.zzCroControl;

      button.dataset.zzCroVariant = variant;
      if (label && expectedLabel && label.textContent.trim() !== expectedLabel) {
        label.textContent = expectedLabel;
      }

      var exposureKey = 'zz_cro_exposure_' + experiment + '_' + window.location.pathname;
      if (!readStoredValue(window.sessionStorage, exposureKey)) {
        emit('cro_exposure', {
          experiment: experiment,
          variant: variant,
          product_path: window.location.pathname,
          device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
        });
        writeStoredValue(window.sessionStorage, exposureKey, '1');
      }
    }

    syncMobileAssurance();
    window.setTimeout(syncMobileAssurance, 800);
    window.setTimeout(syncMobileAssurance, 2200);

    var packageContents = document.querySelector('[data-zz-package-contents]');
    if (packageContents && 'IntersectionObserver' in window) {
      var packageContentsObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        emit('package_contents_viewed', {
          product_path: window.location.pathname,
          device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
        });
        packageContentsObserver.disconnect();
      }, { threshold: 0.5 });
      packageContentsObserver.observe(packageContents);
    }
  }

  function isCartAdd(input) {
    try {
      var raw = typeof input === 'string' ? input : input && input.url;
      if (!raw) return false;
      return /\/cart\/add(?:\.js)?\/?$/.test(new URL(raw, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  }

  function cartMutationType(input) {
    try {
      var raw = typeof input === 'string' ? input : input && input.url;
      if (!raw) return '';
      var path = new URL(raw, window.location.origin).pathname;
      if (/\/cart\/add(?:\.js)?\/?$/.test(path)) return 'add';
      if (/\/cart\/(?:change|update|clear)(?:\.js)?\/?$/.test(path)) return 'update';
    } catch (error) {
      return '';
    }
    return '';
  }

  function isCartSyncRequest(init) {
    var headers = init && init.headers;
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.get('X-Zumzz-Cart-Sync') === '1';
    }
    if (Array.isArray(headers)) {
      return headers.some(function (entry) {
        return String(entry[0]).toLowerCase() === 'x-zumzz-cart-sync' && String(entry[1]) === '1';
      });
    }
    return Object.keys(headers).some(function (key) {
      return key.toLowerCase() === 'x-zumzz-cart-sync' && String(headers[key]) === '1';
    });
  }

  function importChildren(target, source) {
    target.replaceChildren.apply(
      target,
      Array.from(source.childNodes, function (node) {
        return document.importNode(node, true);
      })
    );
  }

  function settleAddButtons() {
    document.querySelectorAll('.product-form__submit.loading, .main-product-atc.loading').forEach(function (button) {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      button.disabled = false;
    });
  }

  function renderCartSnapshot(sections, openDrawer) {
    if (!sections || !sections['cart-drawer']) return false;

    var parser = new DOMParser();
    var drawerDocument = parser.parseFromString(sections['cart-drawer'], 'text/html');
    var nextHost = drawerDocument.querySelector('cart-drawer');
    var nextDrawer = drawerDocument.querySelector('#CartDrawer');
    var currentHost = document.querySelector('cart-drawer');
    var currentDrawer = currentHost && currentHost.querySelector('#CartDrawer');
    if (!nextDrawer || !currentHost || !currentDrawer) return false;

    // Replace the complete drawer snapshot in one operation. This guarantees
    // that line items, subtotal and checkout value are from one server state.
    importChildren(currentDrawer, nextDrawer);
    currentHost.classList.toggle('is-empty', !!(nextHost && nextHost.classList.contains('is-empty')));

    var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof currentHost.close === 'function') {
      overlay.addEventListener('click', currentHost.close.bind(currentHost));
    }

    if (sections['cart-icon-bubble']) {
      var bubbleDocument = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var nextBubble = bubbleDocument.querySelector('#cart-icon-bubble .shopify-section') ||
        bubbleDocument.querySelector('.shopify-section');
      var currentBubble = document.getElementById('cart-icon-bubble');
      if (nextBubble && currentBubble) importChildren(currentBubble, nextBubble);
    }

    if (openDrawer && !currentHost.classList.contains('is-empty')) {
      currentHost.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }

    settleAddButtons();
    document.dispatchEvent(new CustomEvent('cartQuantityUpdated', { bubbles: true }));
    return true;
  }

  function syncCartSnapshot() {
    if (cartSyncRunning) {
      cartSyncQueued = true;
      return;
    }

    cartSyncRunning = true;
    var requestedRevision = cartMutationRevision;
    var shouldOpenDrawer = cartSyncOpenDrawer;
    cartSyncOpenDrawer = false;

    nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Zumzz-Cart-Sync': '1'
      },
      body: JSON.stringify({
        updates: {},
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_sync_failed');
        return response.json();
      })
      .then(function (data) {
        // A newer mutation may have completed while this snapshot was in
        // flight. Never paint an older cart over the latest shopper action.
        if (requestedRevision === cartMutationRevision) {
          renderCartSnapshot(data.sections, shouldOpenDrawer);
        } else {
          cartSyncOpenDrawer = cartSyncOpenDrawer || shouldOpenDrawer;
        }
      })
      .catch(function () {
        // The original cart mutation already succeeded. Keep the current UI and
        // release its loading state so the shopper can retry or open /cart.
        settleAddButtons();
      })
      .finally(function () {
        cartSyncRunning = false;
        if (cartSyncQueued || requestedRevision !== cartMutationRevision) {
          cartSyncQueued = false;
          window.clearTimeout(cartSyncTimer);
          cartSyncTimer = window.setTimeout(syncCartSnapshot, 80);
        }
      });
  }

  function scheduleCartSync(openDrawer) {
    cartMutationRevision += 1;
    cartSyncOpenDrawer = cartSyncOpenDrawer || openDrawer;
    window.clearTimeout(cartSyncTimer);
    cartSyncTimer = window.setTimeout(syncCartSnapshot, 180);
  }

  function readVariant(body) {
    try {
      if (body instanceof FormData) return body.get('id') || '';
      if (typeof body === 'string') {
        var parsed = JSON.parse(body);
        return parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id) || '';
      }
    } catch (error) {
      return '';
    }
    return '';
  }

  function showError(message) {
    var toast = document.getElementById('ZumzzCartError');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ZumzzCartError';
      toast.className = 'zz-cart-error';
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      document.body.appendChild(toast);
    }
    toast.textContent = message || 'Proizvod nije dodan. Pokušajte ponovno.';
    toast.classList.add('zz-cart-error--visible');
    window.clearTimeout(toast.__hideTimer);
    toast.__hideTimer = window.setTimeout(function () {
      toast.classList.remove('zz-cart-error--visible');
    }, 5000);
  }

  // A direct-checkout package can already be in the cart when a shopper returns
  // from checkout. Re-adding it would silently increase its quantity.
  var packageButton = document.querySelector('.main-product-form [data-zz-cro-variant="package_buy_now"]');
  var packageStickyButton = packageButton && document.querySelector('sticky-atc .main-product-atc');
  var packageClickBypass = false;
  var packageCheckPending = false;
  var packageSubmissionInFlight = false;
  var packageSubmissionTimer = null;
  function finishPackageSubmission() {
    packageSubmissionInFlight = false;
    window.clearTimeout(packageSubmissionTimer);
  }
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function packageVariantId() {
    var form = packageButton && packageButton.closest('form');
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }
  function packageInCart(cart) {
    var variantId = packageVariantId();
    return !!(variantId && cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      return String(item.variant_id) === variantId;
    }));
  }
  function updatePackageButton(inCart) {
    if (!packageButton) return;
    var label = packageButton.querySelector('.main-atc__label__text');
    if (!label) return;
    if (!packageButton.dataset.zzPackageOriginalLabel) {
      packageButton.dataset.zzPackageOriginalLabel = label.textContent.trim();
    }
    var language = (document.documentElement.lang || 'hr').split('-')[0];
    var cartLabel = language === 'de' ? 'Warenkorb bearbeiten' :
      language === 'en' ? 'Edit cart' : 'Uredi košaricu';
    label.textContent = inCart ? cartLabel : packageButton.dataset.zzPackageOriginalLabel;
    packageButton.classList.toggle('zz-package-already-in-cart', inCart);
    var price = packageButton.querySelector('.main-atc-price');
    if (price) price.classList.toggle('hidden', inCart);
    if (packageStickyButton) {
      var stickyLabel = packageStickyButton.querySelector('.sticky-atc__label__text');
      if (stickyLabel) {
        if (!packageStickyButton.dataset.zzPackageOriginalLabel) {
          packageStickyButton.dataset.zzPackageOriginalLabel = stickyLabel.textContent.trim();
        }
        stickyLabel.textContent = inCart ? cartLabel : packageStickyButton.dataset.zzPackageOriginalLabel;
      }
      var stickyPrice = packageStickyButton.querySelector('[id^="sticky-atc-price-"]');
      if (stickyPrice) stickyPrice.classList.toggle('hidden', inCart);
    }
  }
  function readCart() {
    return nativeFetch(cartRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_read_failed');
        return response.json();
      });
  }
  function refreshPackageButton() {
    if (!packageButton) return;
    readCart().then(function (cart) {
      updatePackageButton(packageInCart(cart));
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    if (packageStickyButton && packageStickyButton.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!packageCheckPending) packageButton.click();
      return;
    }
    if (!packageButton || !packageButton.contains(event.target)) return;
    if (packageClickBypass) {
      packageClickBypass = false;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (packageCheckPending || packageSubmissionInFlight || packageButton.disabled) return;
    packageCheckPending = true;
    packageButton.disabled = true;
    readCart().then(function (cart) {
      if (packageInCart(cart)) {
        updatePackageButton(true);
        window.location.assign(cartRoot() + 'cart');
        return;
      }
      updatePackageButton(false);
      packageButton.disabled = false;
      packageSubmissionInFlight = true;
      packageSubmissionTimer = window.setTimeout(function () {
        finishPackageSubmission();
        refreshPackageButton();
      }, 12000);
      packageClickBypass = true;
      packageButton.click();
    }).catch(function () {
      showError('Košaricu nije moguće provjeriti. Pokušajte ponovno.');
      packageButton.disabled = false;
    }).finally(function () {
      packageCheckPending = false;
      packageClickBypass = false;
    });
  }, true);

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var checkout = event.target.closest('#CartDrawer-Checkout, [name="checkout"], a[href*="/checkout"]');
    if (checkout) {
      emit('checkout_clicked', {
        source: checkout.closest('cart-drawer') ? 'cart_drawer' : 'cart_page',
        product_path: window.location.pathname
      });
      return;
    }

    var addButton = event.target.closest(
      '.product-form__submit, .main-product-atc, [data-variant-id][class*="-atc"], cart-drawer-upsell button'
    );
    if (!addButton || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') return;
    pendingInteraction = buttonContext(addButton);
    pendingInteraction.started_at = Date.now();
    emit('add_to_cart_attempt', pendingInteraction);
    if (pendingInteraction.cro_variant === 'package_buy_now') {
      emit('package_buy_now_attempt', pendingInteraction);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('[data-product-accordion] [data-accordion-trigger]');
    if (!trigger || !document.querySelector('[data-zz-package-contents]') || trigger.getAttribute('aria-expanded') === 'true') return;
    emit('package_contents_opened', {
      product_path: window.location.pathname,
      label: (trigger.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80)
    });
  }, true);

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var mutationType = cartMutationType(input);
    var isOwnSync = isCartSyncRequest(init);
    if (!isCartAdd(input)) {
      var passthroughRequest = nativeFetch(input, init);
      if (mutationType && !isOwnSync) {
        passthroughRequest.then(function (response) {
          if (response.ok) scheduleCartSync(false);
        }).catch(function () {});
      }
      return passthroughRequest;
    }

    var context = Object.assign({}, pendingInteraction || {}, {
      product_path: (pendingInteraction && pendingInteraction.product_path) || window.location.pathname,
      variant_id: readVariant(init && init.body) || (pendingInteraction && pendingInteraction.variant_id) || ''
    });
    var startedAt = performance.now();
    var request = nativeFetch(input, init);

    request.then(function (response) {
      response.clone().json().catch(function () { return {}; }).then(function (data) {
        context.duration_ms = Math.round(performance.now() - startedAt);
        context.status = response.status;

        if (response.ok && !data.status) {
          emit('add_to_cart_success', context);
          if (context.cro_variant === 'package_buy_now') {
            emit('package_buy_now_add_success', context);
            finishPackageSubmission();
            refreshPackageButton();
          }
          scheduleCartSync(true);
        } else {
          if (context.cro_variant === 'package_buy_now') finishPackageSubmission();
          context.message = data.description || data.message || 'cart_add_failed';
          emit('add_to_cart_error', context);
          showError(data.description || 'Proizvod nije dodan. Pokušajte ponovno.');
        }
      });
    }).catch(function (error) {
      if (context.cro_variant === 'package_buy_now') finishPackageSubmission();
      context.duration_ms = Math.round(performance.now() - startedAt);
      context.message = error && error.message ? error.message : 'network_error';
      emit('add_to_cart_error', context);
      showError('Veza je prekinuta. Provjerite internet i pokušajte ponovno.');
    });

    return request;
  };

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawerWasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('active');
      if (isOpen && !drawerWasOpen) {
        emit('cart_drawer_opened', { product_path: window.location.pathname });
      }
      drawerWasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeDrawer();
      setupPdpCro();
      refreshPackageButton();
    }, { once: true });
  } else {
    observeDrawer();
    setupPdpCro();
    refreshPackageButton();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    // A bfcache restore can show the cart count from before checkout.
    finishPackageSubmission();
    cartSyncOpenDrawer = false;
    scheduleCartSync(false);
    refreshPackageButton();
  });
  document.addEventListener('cartQuantityUpdated', refreshPackageButton);
})();
